import React from "react";
import { Attribute, AuthorizedUser, Tag } from "./models/User";
import { Country, LocationId, Province, Town } from "./models/Locale";
import { Gift } from "./models/Conversation";
import type { CustomFrontendProps } from "./customFrontend/types";

// Event definitions
interface PayReturnEvent {
  action: 'pay_return';
  data: {
    returnType: 'cancel' | 'success' | 'error' | 'pending';
  };
}

type InitialEvent = PayReturnEvent;

export interface AppProps {
    react: {
      config: number;
      theme: 'light' | 'dark';
    };
    csrfToken: string;
    user? : AuthorizedUser;
    setUser: React.Dispatch<React.SetStateAction<AuthorizedUser | undefined>>;
    whitelabel: {
      name: string;
      wantedGender: string;
      defaultSearchRadius: number;
    };
    location: {
      country: Country;
      province: Province;
      town: Town;
      id: LocationId;
    };
    siteId: number;
    lastMessageId: number;
    data: {
      tags: Attribute[];
      attributes: Attribute[];
      gifts: Gift[];
    };
    texts: any;
    logo: {
      src: string; 
      height: string;
    };
    costs: {
      message: number;
      flirt: number;
    };
    stylesheet: string;
    hideSecondNavbar: boolean;
    setHideSecondNavbar: React.Dispatch<React.SetStateAction<boolean>>;
  // One-time flag to auto-close search form on first mobile load
  searchFormAutoClosedOnce: boolean;
  setSearchFormAutoClosedOnce: React.Dispatch<React.SetStateAction<boolean>>;
    recaptchaSiteKey?: string;
    notifications?: Array<{
      type: 'success' | 'error' | 'warning' | 'info';
      message: string;
      duration?: number;
    }>;
    redirectRoute?: string;
    redirectParams?: Record<string, any>;
    events?: InitialEvent[];
    /** Set when this whitelabel has a custom frontend (`src/sites/<domain>`), see `customFrontend/` */
    customFrontend?: CustomFrontendProps;
}

declare global {
    interface Window {
        reactAppProps: AppProps;
        hasFocus: boolean;
        dataLayer: any[];
        gtag: (...args: unknown[]) => void;
    }
}
export const focusDelayed = (callback : () => void) => {
  if(window.hasFocus){
    callback();
  }else{
    const onFocus = () => {
      callback();
      window.removeEventListener('focus',onFocus);
    };
    window.addEventListener('focus',onFocus);
  }
};
export const AppContext = React.createContext<AppProps>(window.reactAppProps);

// Re-export window as a typed reference to avoid Babel scope tracker warnings
const typedWindow = window as Window & typeof globalThis;
export default typedWindow;